import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/2e0b1e22c1b74afa84b035f494e9bd64/f9b3b131c5912e6a98b6c9a49b3d10f0.png"
                alt="CzechAI Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md font-medium">
              Specializujeme se na implementaci AI řešení pro české firmy. 
              Pomáháme automatizovat procesy, analyzovat data a zvyšovat efektivitu vašeho podnikání.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg text-black"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg text-black"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg text-black"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg text-black"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-tiktok-fill text-lg text-black"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg text-black"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">Rychlé odkazy</h3>
            <ul className="space-y-3">
              <li><Link to="/sluzby" className="text-gray-300 hover:text-white transition-colors cursor-pointer font-medium">Služby</Link></li>
              <li><Link to="/sluzby-detailne" className="text-gray-300 hover:text-white transition-colors cursor-pointer font-medium">Služby detailně</Link></li>
              <li><Link to="/o-nas" className="text-gray-300 hover:text-white transition-colors cursor-pointer font-medium">O nás</Link></li>
              <li><Link to="/kontakt" className="text-gray-300 hover:text-white transition-colors cursor-pointer font-medium">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">Kontakt</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-white"></i>
                <span className="font-medium">+420 732 941 900</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-white"></i>
                <span className="font-medium">info@czechai.io</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-global-line text-white"></i>
                <span className="font-medium">www.czechai.io</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-300 font-medium">
            © 2022-2026 CzechAI. Všechna práva vyhrazena.
          </p>
        </div>
      </div>
    </footer>
  );
}
